// extracted by mini-css-extract-plugin
export var card = "_qr-0";
export var content = "_qr-2";
export var details = "_qr-3";
export var icon = "_qr-1";
export var iconBlue = "_qr-5";
export var iconBrand = "_qr-4";
export var iconGrayBlue = "_qr-6";
export var iconGreen = "_qr-7";
export var iconIndigo = "_qr-8";
export var iconOrange = "_qr-9";
export var iconPurple = "_qr-a";
export var iconRed = "_qr-b";
export var iconWarning = "_qr-c";